const HealthCheck = () => {
  return(
    <h3>Health check success</h3>
  );
};

export default HealthCheck;